import axios from 'axios';
import logger from '../../../helpers/Logger';
import { v4 as uuidv4 } from 'uuid';

export function waitForMessage(
  ws: WebSocket,
  predicate: (msg: any) => boolean,
  timeoutMs = 30000
): Promise<any> {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      ws.removeEventListener('message', onMessage);
      reject(new Error('Timed out waiting for WebSocket message'));
    }, timeoutMs);

    function onMessage(event: MessageEvent) {
      try {
        const data = JSON.parse(event.data);
        if (predicate(data)) {
          clearTimeout(timer);
          ws.removeEventListener('message', onMessage);
          resolve(data);
        }
      } catch (err) {
        console.warn('Invalid JSON from WS:', event.data);
      }
    }

    ws.addEventListener('message', onMessage);
  });
}

export const createWSConnection = async (token: string) => {
  try {
    const customHeaders = {
      Authorization: `Bearer ${token}`
    };
    const queryParams = new URLSearchParams(customHeaders).toString();
    let pingInterval: NodeJS.Timeout;
    const ws = new WebSocket(`${process.env.REACT_APP_WS}?${queryParams}`);
    let connectionId;
    ws.onopen = () => {
      logger.info('WebSocket connection established');

      pingInterval = setInterval(
        () => {
          if (ws?.readyState === WebSocket.OPEN) {
            ws.send(JSON.stringify({ type: 'ping' }));
            logger.info('Ping sent');
          }
        },
        5 * 60 * 1000
      ); // 4 minutes
      ws.send(
        JSON.stringify({
          action: 'connectionId',
          message: [
            {
              messageToken: `${token}`
            }
          ]
        })
      );
    };

    ws.onerror = (error) => {
      logger.error('WebSocket error:', error);
      throw Error(`Websocket Error`);
    };
    return ws;
  } catch (e) {
    const error = e as Error;
    throw Error(error.message);
  }
};

export const getDOCXPageCount = async (
  ws: WebSocket,
  docxFile: File,
  connectionId: string,
  auth: any
) => {
  try {
    const uuid = uuidv4();
    const presignedUrl = await axios.post(
      `${process.env.REACT_APP_KORU_API}/get-presigned-url?type=uploadDOCX&auth=self`,
      {
        documentId: `${uuid}`,
        connectionId: connectionId
      },
      auth
    );
    const putResult = await axios.put(presignedUrl.data.url, docxFile, {
      headers: {
        'Content-Type':
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      }
    });
    console.log('put result S3', putResult);
    //! this is the data object { key: srcKey, pageCount, documentId },
    const pageCountResult = await waitForMessage(
      ws,
      (msg) => {
        return msg.type === 'pageCount' && msg.data.documentId === uuid;
      },
      300000
    ); // 30s timeout
    logger.info('page count data', pageCountResult);
    return pageCountResult;
  } catch (e) {
    const error = e as Error;
    throw Error(error.message);
  }
};
